import { render, staticRenderFns } from "./GalleryFilterOptions.vue?vue&type=template&id=12677dde"
import script from "./GalleryFilterOptions.vue?vue&type=script&lang=js"
export * from "./GalleryFilterOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports